import React from 'react'

const LockIcon = props => (
  <svg viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.75676 6.16762C9.5947 5.99526 9.39802 5.90913 9.16639 5.90913H8.88884V4.1363C8.88884 3.00375 8.50688 2.03132 7.74306 1.21879C6.97913 0.406264 6.06486 0 4.99995 0C3.93503 0 3.02066 0.406264 2.25684 1.21879C1.49291 2.03132 1.11105 3.00375 1.11105 4.1363V5.90913H0.833289C0.601873 5.90913 0.405085 5.99526 0.243029 6.16762C0.0809745 6.33987 0 6.54918 0 6.79555V12.1137C0 12.3598 0.0809745 12.5691 0.243029 12.7415C0.405085 12.9138 0.601873 13 0.833289 13H9.1666C9.39823 13 9.59492 12.9139 9.75697 12.7415C9.91892 12.5691 10 12.3598 10 12.1137V6.79543C10.0001 6.5493 9.91892 6.33999 9.75676 6.16762ZM7.22216 5.90913H2.77774V4.1363C2.77774 3.4839 2.99477 2.9268 3.42883 2.46524C3.8629 2.00356 4.38657 1.77283 5.00005 1.77283C5.61354 1.77283 6.13721 2.00356 6.57117 2.46524C7.00513 2.9268 7.22216 3.4839 7.22216 4.1363V5.90913Z"
      fill="currentColor"
    />
  </svg>
)

export default LockIcon
